import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./sidebar.css";

export default function Sidebar() {
  const [cats, setCats] = useState([]);

  useEffect(() => {
    const getCats = async () => {
      const res = await axios.get("/categories");
      setCats(res.data);
    };
    getCats();
  }, []);

  function Fb() {
    window.location.href = "https://www.facebook.com/profile.php?id=100018630789780";
 }

 function twit() {
  window.location.href = "https://twitter.com/Deepak25326607";
}

function insta() {
  window.location.href = "https://www.instagram.com/kr_deepak25/";
}

function git() {
  window.location.href = "https://github.com/Deepak931014";
}

  return (
    <div className="sidebar">
      <div className="sidebarItem">
        <span className="sidebarTitle">ABOUT ME</span>
        <img
          src="https://deepak-portfolio-website.netlify.app/static/media/deepu.8aeb688796d7006de407.png"
          alt="Author"
        />
        <p>
         Hi, i'm Deepak Kumar <br/> A MERN Stack Developer <br/> Welcome to my Blog Website <br/> There you can post daily blogs.
        </p>
      </div>
      
    {/*
      <div className="sidebarItem">
        <span className="sidebarTitle">CATEGORIES</span>
        <ul className="sidebarList">
          {cats.map((c) => (
            <Link to={`/?cat=${c.name}`} className="link">
            <li className="sidebarListItem">{c.name}</li>
            </Link>
          ))}
        </ul>
      </div>
          */}

      <div className="sidebarItem">
        <span className="sidebarTitle">FOLLOW US</span>
        <div className="sidebarSocial">
          <i className="sidebarIcon fab fa-facebook-square" onClick={Fb}></i>
          <i className="sidebarIcon fab fa-twitter-square" onClick={twit}></i>
          <i className="sidebarIcon fab fa-github-square" onClick={git}></i>
          <i className="sidebarIcon fab fa-instagram-square" onClick={insta}></i>
        </div>
      </div>
    </div>
  );
}
